import { MutationOptions, useMutation } from '@tanstack/react-query';
import { acceptGoTuTermsService } from '../acceptGoTuTermsService';
import {
  IAcceptGoTuTermsPayload,
  IAcceptGoTuTermsResponse,
} from '../acceptGoTuTermsTypes';

export const useAcceptGoTuTerms = (
  options?: MutationOptions<
    IAcceptGoTuTermsResponse,
    Error,
    IAcceptGoTuTermsPayload,
    unknown
  >
) => {
  return useMutation<IAcceptGoTuTermsResponse, Error, IAcceptGoTuTermsPayload>({
    mutationFn: async (payload: IAcceptGoTuTermsPayload) => {
      return acceptGoTuTermsService.acceptGoTuTerms(payload);
    },
    ...options,
  });
};
